
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as gps_46htmlyIkR7KM75iIBw0vKsGrcB1mW_BgwZU090KKNuM3Gk68Meta } from "/app/pages/gps.html.vue?macro=true";
import { default as indexmpdCPnD4biHsGmFQDp4qP8uVd5Uj70QHpgxuW6MtniYMeta } from "/app/pages/[area]/index.vue?macro=true";
import { default as indexnuYtgPaPdX4tVKehNxVqrLaA1Mm9FvqQEB4ON7qPSKEMeta } from "/app/pages/topics/index.vue?macro=true";
import { default as indexgi9mEVCmBm_45Kj7_45rP6syC_Qet8FaOABYMg_TTyMd0zQMeta } from "/app/pages/okinawa/index.vue?macro=true";
import { default as indexHzwmRdiCjXCvbVsOTQE_453BgalBH3x4C5LSOm2e3aUxYMeta } from "/app/pages/[area]/[pref]/index.vue?macro=true";
import { default as indextSfakYAwH_vMHcq2MAwtsBLd69WddOQgUR0RI_8HBM8Meta } from "/app/pages/okinawa/[ccode]/index.vue?macro=true";
import { default as index6A3TLYD0ohtVm6tnZ_RDPmOx5G3CQilxeUaOYXSLkpQMeta } from "/app/pages/[area]/[pref]/[ccode]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "gps.html",
    path: "/gps.html",
    meta: gps_46htmlyIkR7KM75iIBw0vKsGrcB1mW_BgwZU090KKNuM3Gk68Meta || {},
    component: () => import("/app/pages/gps.html.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/app/pages/[area]/index.vue")
  },
  {
    name: "topics",
    path: "/topics",
    component: () => import("/app/pages/topics/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/app/pages/okinawa/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/app/pages/[area]/[pref]/index.vue")
  },
  {
    name: "okinawa-ccode",
    path: "/okinawa/:ccode()",
    component: () => import("/app/pages/okinawa/[ccode]/index.vue")
  },
  {
    name: "area-pref-ccode",
    path: "/:area()/:pref()/:ccode()",
    component: () => import("/app/pages/[area]/[pref]/[ccode]/index.vue")
  }
]